import { CompanyInformation } from '../../models';
import { FetchContext, responseErrorHandler } from '..';

export const getCurrentUserCompanyInformation: (
  fetchContext: FetchContext,
  accountId: string,
  accessToken?: string,
) => Promise<CompanyInformation> = (fetchContext, accountId, accessToken) => fetch(`${fetchContext.baseUrl}/api/me/${accountId}/company-information`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<CompanyInformation>(fetchContext.errorStore, response, 'get current user company information'));
